import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Home from './Pages/Home.js'
import Test1 from './Pages/Test1.js'
import Test2 from './Pages/Test2.js'
import Test3 from './Pages/Test3.js'
import AxiosTest from './Pages/AxiosTest.js'
import AxiosSearch from './Pages/AxiosSearch.js'
import VideoDetail from './Pages/VideoDetail.js'
import ChannelDetail from './Pages/ChannelDetail.js'
import Contact from './Pages/Contact.js'
import Error404 from './Pages/Error404.js'
export default function MainRouter() {
    return (
        <div>
            <Routes>
                <Route path="/" element={<Home/>}/>
                <Route path="/test1" element = {<Test1/>}/>
                <Route path="/test2" element = {<Test2/>}/>
                <Route path="/test3" element = {<Test3/>}/>
                <Route path="/axiostest" element = {<AxiosTest/>}/>
                <Route path="/axiossearch" element = {<AxiosSearch/>}/>
                <Route path='/video/:id' element={<VideoDetail />} />
                <Route path='/channel/:id' element={<ChannelDetail />} />
                <Route path="/contact" element = {<Contact/>}/>
                <Route path="*" element = {<Error404/>}/>
            </Routes>            
        </div>
    )
}
